export default __webpack_public_path__ + "img/3ec5e07.svg";